module.exports = __webpack_public_path__ + "img/ru.ecb2c7fa.svg";